let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5XVGB"), load("tLGOl")]).then(() => parcelRequire('anKEx'));